export default "__VITE_ASSET__BVvF1OHN__"